<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    import {fade} from 'svelte/transition';
    import {onMount} from 'svelte';

    export let url = 'https://standardisedwork-test.badevhub.com/sw/static/upload/3558/abde6582-5c81-4dd0-ae2c-0f1a0860d0d4/20180324_062627_thumbnail.jpg';
    export let media = 'http://localhost:8000/sw/static/upload/4034/9eecdbb3-0f95-4269-b651-291f1023169a/793F_Front_Oil_Charge.mp4?sw_version=1.0.67';
    export let name = 'image';
    export let type = 'image'; // IMAGE or VIDEO
    export let thumbnailClass = '';
    export let thumbnailStyles = '';
    export let width = '160px';
    export let height = '90px';
    export let maxHeight = '';
    export let showImage = false;
    export let linkOnly = false;
    export let handleClick = (event) => showImage = true;

    let video = null;

    $: if(media && video) {
        video.load();
    }

    function handleUrlForDev(url){
        if(typeof url === 'string' && url.indexOf('/static/') >= 0){
            if(window.location.host === 'localhost:5000' || window.location.host === '127.0.0.1:5000') {
                url = `http://localhost:8000${url.replace(`${PATH_PREFIX}/sw/static/', '/static/`)}`;
            }
        }
        return url;
    }

    onMount(() => {
        if(video) {
            video.load();
        }
    });
</script>

<style>
    .modal-image {
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        width: 100vw;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        z-index: 1000;
        overflow: auto;
    }

    a {
        font-size: 10px;
        display: flex;
        flex: 1;
    }

    .modal-image img, .modal-image video {
        max-width: 80%;
        margin: auto;
    }

    video, img {
        max-width: 100%;
    }

    .thumbnail {
        /*border: 1px solid #6c757d;*/
        overflow: hidden;
    }
    .thumbnail img, .thumbnail video {
        width: 100%;
    }
</style>

<div class='thumbnail' style={`width: ${width?width:'auto'}; height: ${height?height:'auto'}; max-height: ${maxHeight?maxHeight:'auto'}`}>
    <a
        on:click|preventDefault|stopPropagation={handleClick}
        href={handleUrlForDev(media)}
        target="_blank" rel="noopener noreferrer">
        {#if linkOnly}
            <slot name="linkLabel"/>
        {:else}
            {#if type && type.toUpperCase() === 'IMAGE'}
                <img src={handleUrlForDev(url)} alt={name} class={thumbnailClass} style={thumbnailStyles}/>
            {:else}
                <video bind:this={video} class={thumbnailClass} style={thumbnailStyles}>
                    <source src={handleUrlForDev(media)} alt={name}
                            type="video/mp4">
                </video>
            {/if}
        {/if}
    </a>
</div>


{#if showImage}
<div
    transition:fade|local="{{delay: 50, duration: 150}}"
    class="modal-image"
    on:click={() => showImage = false}>
    {#if type && type.toUpperCase() === 'IMAGE'}
        <img src={handleUrlForDev(media)} alt={name} />
    {:else if type && type.toUpperCase() === 'VIDEO'}
        <video controls >
            <source src={handleUrlForDev(media)} alt={name}
                    type="video/mp4">
        </video>
    {/if}
</div>
{/if}
